<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="swap_calls_24px">
      <path
        id="icon/communication/swap_calls_24px"
        d="M17.65 4.84999L14.86 7.63999C14.54 7.95999 14.76 8.49999 15.21 8.49999H17V15.38C17 16.38 16.33 17.31 15.34 17.47C14.09 17.68 13 16.71 13 15.5V8.66999C13 6.57999 11.47 4.71999 9.39003 4.51999C7.01003 4.28999 5.00003 6.15999 5.00003 8.49999V15.5H3.21003C2.76003 15.5 2.54003 16.04 2.86003 16.35L5.65003 19.14C5.85003 19.34 6.16003 19.34 6.36003 19.14L9.15003 16.35C9.46003 16.04 9.24003 15.5 8.79003 15.5H7.00003V8.61999C7.00003 7.61999 7.67003 6.68999 8.66003 6.52999C9.91003 6.31999 11 7.28999 11 8.49999V15.33C11 17.42 12.53 19.28 14.61 19.48C16.99 19.71 19 17.84 19 15.5V8.49999H20.79C21.24 8.49999 21.46 7.95999 21.14 7.64999L18.35 4.85999C18.16 4.65999 17.84 4.65999 17.65 4.84999Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "CC-routing",
};
</script>
